const DEFAULT_FILTERS = {
  death: false,
  stayHome: false
};

const widthFull = setWidth();

function setWidth() {
  let padding = 24 + 24;
  let w = document.getElementsByTagName('body')[0].clientWidth;
  w = w >= 1024 ? 1024 - padding : w;
  return w;
}

export const CANVAS_SIZE = {
  height: 600,
  width: widthFull
};

export const DESKTOP_CANVAS_SIZE = {
  height: 540,
  width: widthFull
};

export const BALL_RADIUS = 4;
export const COLORS = {
  death: '#c50000',
  recovered: '#EC4646',
  infected: '#EC4646',
  well: '#257AFF'
};

export const STATES = {
  infected: 'infected',
  well: 'well',
  recovered: 'recovered',
  death: 'death'
};

export const COUNTERS = {
  //removed ... and added the STATES
  infected: 'infected',
  well: 'well',
  recovered: 'recovered',
  death: 'death',
  'max-concurrent-infected': 'max-concurrent-infected'
};

export const STARTING_BALLS = {
  [STATES.infected]: 2,
  [STATES.well]: 149,
  [STATES.recovered]: 0,
  [STATES.death]: 0,
  'max-concurrent-infected': 0
};

export const RUN = {
  //removed ... and added the DEFAULT_FILTERS
  filters: {
    death: false,
    stayHome: false
  },
  //removed ... and added the STARTING_BALLS
  results: {
    [STATES.infected]: 1,
    [STATES.well]: 149,
    [STATES.recovered]: 0,
    [STATES.death]: 0,
    'max-concurrent-infected': 0
  },
  tick: 0
};

export const MORTALITY_PERCENTATGE = 5;
export const SPEED = 3;
export const TOTAL_TICKS = 500;
export const TICKS_TO_RECOVER = 499;

export const resetRun = () => {
  RUN.results = {
    [STATES.infected]: 1,
    [STATES.well]: 149,
    [STATES.recovered]: 0,
    [STATES.death]: 0,
    'max-concurrent-infected': 0
  };
  RUN.tick = 0;
};
